import React from 'react'
import styles from './IconButton.module.css'

export function IconButton ({ onClick, icon }) {
  return (
    <button
      className={styles.button}
      type="button"
      onClick={onClick}>
      {icon}
    </button>
  )
}
